import React, { useState } from 'react';
import styled from 'styled-components';
import { SimpleVenueData } from '../../../shared/dto/EntityRepository';
import AdminBlockWithVisible from '../../share/component/AdminBlockWithVisible';
import { useAdminVenueStore } from '../../share/store/adminVenueStore';
import { toInstagramHandle } from './instagramHandle';

interface VenueInfoProps {
  data: SimpleVenueData;
  isSelected: boolean;
  isMarqueeHit: boolean;
  handleClick: (event: React.MouseEvent<HTMLElement>) => void;
}

const toCityDistrict = (city?: string, district?: string): string =>
  [city, district].filter(Boolean).join(' / ') || '-';

const VenueInfo: React.FC<VenueInfoProps> = ({
  data,
  isSelected,
  isMarqueeHit,
  handleClick,
}) => {
  const hasRightPanel = useAdminVenueStore((state) =>
    !!state.activeVenue
    || state.multiSelectedVenueIds.length > 1
    || state.isBulkPreviewOpen
    || (!!state.bulkResult && !state.activeVenue && state.multiSelectedVenueIds.length <= 1),
  );
  const [hovered, setHovered] = useState(false);
  const isHover = hovered || isMarqueeHit;

  return (
    <VenueInfoComp
      data-venue-id={data.id}
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <ContentWrapper>
        <TitleBlock $isHover={isHover} $isActive={isSelected}>
          <TitleText>{data.name}</TitleText>
        </TitleBlock>
        <AdminBlockWithVisible
          width="1.5"
          value={data.type}
          isHover={isHover}
          isActive={isSelected}
        />
        <AdminBlockWithVisible
          width="1.2"
          value={data.admissionType}
          isHover={isHover}
          isActive={isSelected}
        />
        <AdminBlockWithVisible
          width="2"
          value={toCityDistrict(data.city, data.district)}
          isHover={isHover}
          isActive={isSelected}
        />
        <AdminBlockWithVisible
          width="2"
          value={toInstagramHandle(data.instagramUrl)}
          isHover={isHover}
          isActive={isSelected}
        />
        {hasRightPanel && <SpaceBlock />}
      </ContentWrapper>
    </VenueInfoComp>
  );
};

const VenueInfoComp = styled.article`
  position: relative;
  display: flex;
  width: 100%;
  height: 40px;
  min-height: 40px;
  cursor: pointer;

  color: ${({ theme }) => theme.colors.color_Gray_03};
  ${({ theme }) => theme.typography.Body_04};
`;

const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

const TitleBlock = styled.div<{ $isHover: boolean; $isActive: boolean }>`
  flex: 2.4;
  min-width: 0;
  display: flex;
  align-items: center;
  padding-left: 4px;
  text-decoration: ${({ $isActive }) => ($isActive ? 'underline' : 'none')};
  background-color: ${({ theme, $isHover, $isActive }) =>
    $isActive ? theme.colors.color_Gray_06 : $isHover ? theme.colors.color_Gray_07 : 'transparent'};
  border-bottom: 0.5px solid ${({ theme }) => theme.colors.color_Gray_04};
  cursor: pointer;
`;

const TitleText = styled.div`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const SpaceBlock = styled.div`
  flex: 0.15;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: auto;
`;

export default VenueInfo;
